const headRowsGroup = {
  actions: 'Actions',
  name: 'Group'
};

export default headRowsGroup;
